import { render, staticRenderFns } from "./MagiunWeb.vue?vue&type=template&id=5c65419c&scoped=true&"
import script from "./MagiunWeb.vue?vue&type=script&lang=js&"
export * from "./MagiunWeb.vue?vue&type=script&lang=js&"
import style0 from "./MagiunWeb.vue?vue&type=style&index=0&id=5c65419c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c65419c",
  null
  
)

export default component.exports